@if (serverAction) {
    <ws-busy-indicator></ws-busy-indicator>
}
<ws-modal-wrapper
    headerLabel="Shipping Methods"
    acceptLabel="Save"
    (save)="save()"
    (cancel)="cancel()">
    @if (!shippingMethodPackages?.length && !serverAction) {
        <p
            style="font-style: italic">
            No shipping methods found...
        </p>
    }
    @if (shippingMethodPackages?.length) {
        <table
            class="shipping-methods table table-condensed table-striped">
            <thead>
            <tr>
                <th (click)="getIt()">Payee</th>
                <th class="text-align-right"># of Payments</th>
                <th class="text-align-right"># of Checks</th>
                <th class="text-align-right">Total Amount</th>
                <th>Shipping Method</th>
            </tr>
            </thead>
            <tbody>
                @for (row of shippingMethodPackages; track row) {
                    <tr>
                        <td>{{ row.collectorName }}, {{ row.collectorState }} [{{ row.collectorID }}]</td>
                        <td class="text-align-right">{{ row.numberOfPayments }}</td>
                        <td class="text-align-right">{{ row.numberOfChecks }}</td>
                        <td class="text-align-right">{{ row.amount | currency:'USD' }}</td>
                        <td>
                            <ws-select placeholder="Add Collector"
                                       [(ngModel)]="row.shippingMethodId"
                                       [options]="shippingMethods"
                                       labelProperty="name"
                                       valueProperty="id">
                            </ws-select>
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    }
</ws-modal-wrapper>
